'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Standard button component. The two main types of buttons are PrimaryButton and SecondaryButton.
 * See their examples below.
 */
var ButtonBase = function (_Component) {
  _inherits(ButtonBase, _Component);
  function ButtonBase(props) {
    _classCallCheck(this, ButtonBase);
    var _this = _possibleConstructorReturn(this, (ButtonBase.__proto__ || Object.getPrototypeOf(ButtonBase)).call(this, props));
    _this.state = {
      enabled: _this.props.enabled
    };
    _this.handleEnterPress = _this.handleEnterPress.bind(_this);
    return _this;
  }
  _createClass(ButtonBase, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
          tabIndex = _props.tabIndex,
          type = _props.type;
        var id = this.props.id || _lodash2['default'].uniqueId('button_');

        // pass all data- attribute props through, so that components like tooltip can use them.
        var dataDashProps = _lodash2['default'].pickBy(this.props, function (value, key) {
          return key.startsWith('data') === true;
        });
        return _react2['default'].createElement('button', _extends({
          id: id,
          disabled: this.getDisabledProp(),
          onClick: this.clickHandler(),
          type: type,
          onKeyDown: this.handleEnterPress,
          tabIndex: tabIndex,
          title: this.getTitle(),
          className: this.props.className
        }, dataDashProps), this.renderIcon(dataDashProps), this.renderText(dataDashProps));
      }
      return render;
    }()

    /**
     * We need to set the enabled state when the enabled props change
     */
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        var enabled = newProps.enabled;
        if (enabled != this.state.enabled) {
          this.setState({
            enabled: enabled
          });
        }
      }
      return componentWillReceiveProps;
    }()

    /**
     * Helper function to get the enabled state.
     */
  }, {
    key: 'getDisabledProp',
    value: function () {
      function getDisabledProp() {
        return this.state.enabled ? false : true;
      }
      return getDisabledProp;
    }()
  }, {
    key: 'getTitle',
    value: function () {
      function getTitle() {
        // if the data-tip attribute is present then dont show the default tooltip
        if (this.props.hasOwnProperty('data-tip') === false) {
          return this.props.text;
        } else {
          return null;
        }
      }
      return getTitle;
    }()

    /**
     * Returns the clickHandler prop if the button is enabled.
     */
  }, {
    key: 'clickHandler',
    value: function () {
      function clickHandler() {
        if (this.state.enabled) {
          return this.props.clickHandler;
        }
        return null;
      }
      return clickHandler;
    }()

    /**
     * Method called when the enter key is pressed. In turn it calls the click handler function.
     */
  }, {
    key: 'handleEnterPress',
    value: function () {
      function handleEnterPress(evt) {
        var ENTER_KEY_CODE = 13;
        if (evt.keyCode === ENTER_KEY_CODE) {
          var clickEventHandler = this.clickHandler();
          if (clickEventHandler) {
            clickEventHandler(evt);
          }
        }
      }
      return handleEnterPress;
    }()

    /**
     * Function to render the icon of the button only if provided in the icon prop
     */
  }, {
    key: 'renderIcon',
    value: function () {
      function renderIcon(dataDashProps) {
        var icon = this.props.icon;
        if (icon) {
          if (typeof icon === 'string') {
            // eslint-disable-next-line no-console
            console.error('Button Error: Passing a string as the icon prop has been deprecated. Please pass a React element.');
            return null;
          }
          return _react2['default'].createElement('div', _extends({
            name: 'iconContainer'
          }, dataDashProps), icon);
        }
        return null;
      }
      return renderIcon;
    }()

    /**
     * Function to render the text of the button only if provided in the text prop.
     */
  }, {
    key: 'renderText',
    value: function () {
      function renderText(dataDashProps) {
        var text = this.props.text;
        if (text && text.length > 0) {
          return _react2['default'].createElement('div', _extends({
            name: 'buttonText'
          }, dataDashProps), text);
        }
        return null;
      }
      return renderText;
    }()
  }]);
  return ButtonBase;
}(_react.Component);
ButtonBase.defaultProps = {
  clickHandler: function () {
    function clickHandler() {}
    return clickHandler;
  }(),
  enabled: true,
  tabIndex: -1,
  type: 'button'
};
ButtonBase.propTypes = {
  /**
   * Handler for the click event of the button.
   */
  clickHandler: _propTypes2['default'].func.isRequired,
  /**
   * Boolean that enables or disables the button. Defaults to true.
   */
  enabled: _propTypes2['default'].bool,
  /**
   * React element representing an icon.
   */
  icon: _propTypes2['default'].element,
  /**
   * Set which side of the button you want the icon to be on.
   */
  iconPosition: _propTypes2['default'].oneOf(['left', 'right']),
  /**
   * Set pixel font-size of the icon.
   */
  iconSize: _propTypes2['default'].number,
  /**
   * Id for the button, if not provided a unique id is added.
   */
  id: _propTypes2['default'].string,
  /**
   * If set to true the button is rendered as an inline element. Useful when used in overlay title bars. Default is false.
   */
  inline: _propTypes2['default'].bool,
  /**
   * Determines the focusable order of the element in the navigation.
   */
  tabIndex: _propTypes2['default'].number,
  /**
   * Text to display on the button.
   */
  text: _propTypes2['default'].string,
  /**
   * Renders a type attribute in the HTML element. Useful for forms
   */
  type: _propTypes2['default'].oneOf(['button', 'submit', 'reset']),
  /**
   * Sets the pixel width for a button.
   */
  width: _propTypes2['default'].number
};
ButtonBase.displayName = 'Button';
exports['default'] = ButtonBase;